import React, { useState } from 'react'
import "./Verfication.css"
import success from "../../assets/verify/Success.svg"
import fail from "../../assets/verify/fail.svg"
import { Box, Input, Link, Typography } from '@mui/material';

// Add your valid certificate numbers here (case-sensitive)
const VALID_CERTIFICATES = [
  "LDINT2025001",
  "LDINT2025002",
  "LDINT2025003",
  "LDINT2025004",
  // Add more as needed
];

const Verfication = () => {
  const [input, setInput] = useState('');
  const [verified, setVerified] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [checked, setChecked] = useState(false);

  const handleVerify = async () => {
    const trimmed = input.trim();
    setChecked(false);
    if (trimmed !== '') {
      // Case-sensitive check
      if (VALID_CERTIFICATES.includes(trimmed)) {
        const fetchUrl = `/Certificates/${trimmed}.pdf`;
        const url = `${fetchUrl}#toolbar=0&navpanes=0&scrollbar=0`;
        try {
          const res = await fetch(fetchUrl, { method: 'HEAD' });
          if (res.ok) {
            setVerified(true);
            setFileUrl(url);
          } else {
            setVerified(false);
            setFileUrl('');
          }
        } catch {
          setVerified(false);
          setFileUrl('');
        }
      } else {
        setVerified(false);
        setFileUrl('');
      }
      setChecked(true);
    } else {
      setVerified(false);
      setFileUrl('');
      setChecked(true);
    }
  };

  return (
    <Box className='verify-root'>
        <h1 className="verify-title" style={{ marginTop: '0px' }}>VERIFY CERTIFICATE</h1>
        <Box className="verify-form" sx={{ marginTop: '150px' }} >
          <Input
            className="verify-input"
            type="text"
            placeholder="Enter the Certificate Number eg.'LDINT2025...'"
            value={input}
            onChange={e => setInput(e.target.value)}
          />
          <button className="verify-btn" onClick={handleVerify}>Verify</button>
        </Box>
        {checked && (
          verified && fileUrl ? (
            <>
              <div className="verify-status success" style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                <Typography
                  sx={{
                    color: '#FFF',
                    display: 'flex',
                    gap: '15px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  <span className="verify-dot">
                    <Box component="img" src={success} sx={{ alignSelf: 'center', display: 'flex' }} />
                  </span>
                  Certificate verified
                </Typography>
              </div>
              <div className="pdf-container" style={{ display: 'flex', width: "100%", minHeight: '500px', justifyContent: 'center' }} >
                <iframe
                  src={fileUrl}
                  title="Certificate PDF"
                  width="700"
                  height="500"
                  style={{ border: "none", marginTop: "30px", borderRadius: "8px" }}
                />
              </div>
            </>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: "20px" }}>
              <Typography
                sx={{
                  color: '#FFF',
                  display: 'flex',
                  gap: '15px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <span className="verify-dot">
                  <Box component="img" src={fail} sx={{ alignSelf: 'center', display: 'flex' }} />
                </span>
                Certificate Not Found
              </Typography>
              <Typography className='Failtext' sx={{ color: '#FFF', mt: 2, textAlign: 'center', }}>
                The certificate number entered is invalid or not found in our records. Please check and try again.
              </Typography>
            </Box>
          )
        )}

        <Box sx={{ display: 'flex', justifyContent: 'center', margin: "50px 0px" }}>
          <Typography className='footerText'>
            If you believe this is an error or have a query related to certificate verification, please contact us at <Link className='Linktext'>info@ldintertech.com</Link>
          </Typography>
        </Box>
    </Box>
  )
}

export default Verfication